<template>
  <div
    :class="{ shown }"
    class="modalMain user-levels-modal"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            توضیحات درباره سطح کاربران
          </h5>
          <!-- <button
            type="button"
            class="close-modal"
            data-dismiss="modal"
            aria-label="Close"
            @click="close"
          >
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <div class="modal-body">
          <p class="header-levels-modal">
            کاربر گرامی، خوش آمدید ! شما هم اکنون عضو باشگاه مشتریان پردیس
            داریوش کیش هستید و می توانید از امکانات این باشگاه بهره بگیرید .
          </p>
          <p>
            امتیاز کنونی شما به پاس ثبت نام و نخستین ورودتان به
            باشگاه به شما عرضه شده است
          </p>
          <p>
            شما همچنین می توانید با نظرسنجی درباره سرویس های ما یا ارائه
            پیشنهادات سازنده 2 امتیاز دیگر نیز دریافت کنید
          </p>
        </div>
        <div class="modal-footer">
          <!-- <a href="/club/clubdashboard" type="button" class="btn btn-primary">
            پنل باشگاه مشتریان
          </a> -->
          <!-- <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="close"
          >
            </button> -->
          <button type="button" class="btn btn-primary" @click="close">
            بستن
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shown: "",
    };
  },
  methods: {
    close() {
      this.$emit("closeModal", "closeModal");
      const data = {
        businessId: this.$store.getters.GetCustomerClubData.businessId,
        isSeenIntroduction: true,
      };
      this.$store.dispatch("updateSeenIntroduction", data);
      this.$router.push("/profile");
    },
    getTimeout() {
      // setTimeout(function () {this.shown = "show";} , 1000)
      // this.shown = "show";
      setTimeout(() => {
        this.shown = "show";
      }, 1000);
    },
  },
  beforeMount() {
    this.getTimeout();
  },
  created: function () {
    this.getTimeout();
  },
};
</script>
<style>
.modalMain .modal-dialog {
  max-width: 70%;
  margin-left: auto !important;
  transform: translate(0, -10%) !important;
  -webkit-transform: translate(0, -10%) !important;
  left: 0 !important;
}
</style>